import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const getActiveCuttingLinePathCommand = (self) => {
  const active_idx = self._path_editor_list.findIndex(({ model }) =>
    model.getIsTargetPointSelected()
  );
  return self._path_editor_list[active_idx]?.model;
};
